import React, { useState, useContext, useEffect } from "react";
import { MyContext } from "../../../MyContextApi";
import { Modal, Box, Button } from "@mui/material";
import { startOfWeek, endOfWeek } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRangePicker } from "react-date-range";

/*************  ✨ Windsurf Command 🌟  *************/
const DateRangePickerModal = () => {
  const { setNewDate, dashboardDate, setDashboardDate } = useContext(MyContext);
  const [open, setOpen] = useState(false);

  // Calculate the current week's Monday and Sunday
  const getThisWeekRange = () => {
    const today = new Date();
    const start = startOfWeek(today, { weekStartsOn: 0 }); // Sunday
    const end = endOfWeek(today, { weekStartsOn: 0 }); // Saturdays
    return [
      {
        startDate: start,
        endDate: end,
        key: "selection",
      },
    ];
  };

  // State for the date range
  const [newDate, setLocalDate] = useState(getThisWeekRange());

  const adjustDateTimeRange = (dateRange) => {
     
    return dateRange.map((range) => ({
      startDate: `${range.startDate.toISOString().split("T")[0]}T23:59:59Z`,
      endDate: `${range.endDate.toISOString().split("T")[0]}T23:59:59Z`,
    }));
  };

  const handleDateChange = (item) => {
     
    setLocalDate([item.selection]);
  };

  useEffect(() => {
     
    const adjustedDates = adjustDateTimeRange(newDate);
    setDashboardDate(adjustedDates);
  }, [newDate, setDashboardDate]);

  return (
    <div>
      <DateRangePicker
        onChange={handleDateChange}
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        months={2}
        ranges={newDate}
        direction="horizontal"
        maxDate={new Date()} // ⛔ Prevents selection beyond today
      />
    </div>
  );
};
/*******  d7320064-d8e6-4643-a465-f4430f0b0d15  *******/

export default DateRangePickerModal;
